import { CdnSettings } from './AemConfigurationTypes';
import { ImagePathWithRenditions } from './ImageTypes';
import { ProductDeliveryPromiseExplanations } from './product-detail';

export type ClickMapMarker = {
  markerId: number;
  point: {
    x: number;
    y: number;
  };
  product: {
    id: string;
    color: string;
  };
  productFallback?: {
    id: string;
    color: string;
  };
};

export type ProductInspirationProps = {
  title?: string;
  subTitle?: string;
  image: ImagePathWithRenditions & {
    clickMaps?: { [key: string]: Array<ClickMapMarker> };
    lazy?: boolean;
  };
  buttons?: Array<{
    alt: string;
    href: string;
    label: string;
    target: boolean;
    variant: string;
    iconLeft: string;
    iconRight: string;
  }>;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  cdnSettings?: CdnSettings;
};
